import React, { useState, useMemo, useEffect } from 'react';

const UserManualSidebar = ({ sections, activeKey, onSelectArticle }) => {
  const activeParts = useMemo(() => {
    if (!activeKey) return {};
    const [sectionSlug, chapterSlug] = activeKey.split('/');
    return { sectionSlug, chapterSlug };
  }, [activeKey]);

  const [expandedSections, setExpandedSections] = useState(() => {
    const initial = {};
    sections.forEach((section) => {
      initial[section.slug] = section.slug === activeParts.sectionSlug;
    });
    return initial;
  });

  const [expandedChapters, setExpandedChapters] = useState(() => {
    const initial = {};
    sections.forEach((section) => {
      section.chapters.forEach((chapter) => {
        const key = `${section.slug}/${chapter.slug}`;
        initial[key] = section.slug === activeParts.sectionSlug && chapter.slug === activeParts.chapterSlug;
      });
    });
    return initial;
  });

  useEffect(() => {
    if (!activeKey) return;
    const parts = activeKey.split('/');
    if (parts.length < 2) return;
    const [sectionSlug, chapterSlug] = parts;
    setExpandedSections((prev) => ({ ...prev, [sectionSlug]: true }));
    setExpandedChapters((prev) => ({ ...prev, [`${sectionSlug}/${chapterSlug}`]: true }));
  }, [activeKey]);

  const toggleSection = (slug) => {
    setExpandedSections((prev) => ({ ...prev, [slug]: !prev[slug] }));
  };

  const toggleChapter = (sectionSlug, chapterSlug) => {
    const key = `${sectionSlug}/${chapterSlug}`;
    setExpandedChapters((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="user-manual-toc">
      {sections.map((section) => (
        <div key={section.slug} className="user-manual-toc-section">
          <button
            type="button"
            className={`user-manual-toc-section-header ${expandedSections[section.slug] ? 'expanded' : ''}`}
            onClick={() => toggleSection(section.slug)}
          >
            <span className="user-manual-toc-arrow">
              {expandedSections[section.slug] ? '\u25BE' : '\u25B8'}
            </span>
            <strong>{section.title}</strong>
          </button>
          {expandedSections[section.slug] && (
            <div className="user-manual-toc-chapters">
              {section.chapters.map((chapter) => {
                const chapterKey = `${section.slug}/${chapter.slug}`;
                return (
                  <div key={chapter.slug} className="user-manual-toc-chapter">
                    <button
                      type="button"
                      className={`user-manual-toc-chapter-header ${expandedChapters[chapterKey] ? 'expanded' : ''}`}
                      onClick={() => toggleChapter(section.slug, chapter.slug)}
                    >
                      <span className="user-manual-toc-arrow">
                        {expandedChapters[chapterKey] ? '\u25BE' : '\u25B8'}
                      </span>
                      {chapter.title}
                    </button>
                    {expandedChapters[chapterKey] && (
                      <ul className="user-manual-toc-articles">
                        {chapter.articles.map((article) => {
                          const articleKey = `${section.slug}/${chapter.slug}/${article.slug}`;
                          const isActive = articleKey === activeKey;
                          return (
                            <li key={article.slug}>
                              <a
                                href={`#${articleKey}`}
                                className={`user-manual-toc-article-link ${isActive ? 'active' : ''}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  onSelectArticle(articleKey);
                                }}
                              >
                                {article.title}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserManualSidebar;
